import { useEffect } from "react";
import { useTheme } from "../../contexts/ThemeContext";

// Modal genérico: overlay escurecido, fecha com ESC ou clique fora,
// bloqueia scroll do body enquanto aberto.
export default function Modal({ open, title, subtitle, onClose, children, width = 520 }) {
  const { C, isDark } = useTheme();

  useEffect(() => {
    if (!open) return;
    function onKey(e) {
      if (e.key === "Escape") onClose?.();
    }
    window.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: isDark ? "rgba(0,0,0,0.6)" : "rgba(15,25,35,0.35)",
        backdropFilter: "blur(2px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        padding: 20,
        fontFamily: "'DM Sans', sans-serif",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          maxWidth: width,
          maxHeight: "90vh",
          overflow: "auto",
          background: C.bgCard,
          borderRadius: 16,
          border: `1px solid ${C.border}`,
          boxShadow: isDark
            ? "0 30px 80px rgba(0,0,0,0.5)"
            : "0 30px 80px rgba(0,0,0,0.15)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            padding: "22px 26px 16px",
            borderBottom: `1px solid ${C.border}`,
          }}
        >
          <div>
            <h2 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: C.text }}>
              {title}
            </h2>
            {subtitle && (
              <p style={{ margin: "4px 0 0", fontSize: 12, color: C.textMuted }}>
                {subtitle}
              </p>
            )}
          </div>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              color: C.textMuted,
              fontSize: 22,
              cursor: "pointer",
              padding: 0,
              lineHeight: 1,
              marginLeft: 16,
            }}
            aria-label="Fechar"
          >
            ×
          </button>
        </div>
        <div style={{ padding: "20px 26px 24px" }}>{children}</div>
      </div>
    </div>
  );
}
